<template>
  <div class="card">
    <div class="card-header">
      {{ isEditing ? $t("Edit Problem Department") : $t("Create Problem Department") }}
    </div>
    <div class="card-body">
      <b-form @submit.prevent="handleSubmit">
        <!-- Company Selection -->
        <b-form-group
          label="Company"
          :state="getFieldState('company_id')"
          invalid-feedback="Please select a company"
        >
          <b-form-select
            v-model="form.company_id"
            :options="formattedCompanies"
            :state="getFieldState('company_id')"
            required
          >
            <option value="">{{ $t("Select company") }}</option>
          </b-form-select>
        </b-form-group>

        <!-- Name Input -->
        <b-form-group
          label="Department Name"
          :state="getFieldState('name')"
          invalid-feedback="Department name is required"
        >
          <b-form-input
            v-model="form.name"
            :state="getFieldState('name')"
            required
          ></b-form-input>
        </b-form-group>

        <!-- Submit Button -->
        <b-button :disabled="loading" variant="primary" type="submit">
          <span v-if="loading" class="spinner-border spinner-border-sm" role="status"></span>
          {{ isEditing ? $t("Save") : $t("Create") }}
        </b-button>
      </b-form>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "ProblemDepartmentForm",
  props: {
    problemDepartment: {
      type: Object,
      default: () => ({})
    },
    companies: {
      type: Array,
      required: true
    },
    formAction: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      form: {
        company_id: this.problemDepartment.company_id || "",
        name: this.problemDepartment.name || ""
      },
      errors: {},
      loading: false
    };
  },
  computed: {
    isEditing() {
      return !!this.problemDepartment.id; // Si `id` existe, on est en mode édition
    },
    formattedCompanies() {
      return this.companies.map(company => ({
        value: company.id,
        text: company.name
      }));
    }
  },
  methods: {
    getFieldState(field) {
      return this.errors[field] === undefined ? null : false;
    },
    async handleSubmit() {
      this.loading = true;
      this.errors = {};

      try {
        const method = this.isEditing ? "put" : "post";

        await axios[method](this.formAction, this.form);

        this.$bvToast.toast(
          this.isEditing
            ? "Problem department updated successfully!"
            : "Problem department created successfully!",
          {
            title: "Success",
            variant: "success",
            solid: true
          }
        );

        setTimeout(() => {
          window.location.href = "/settings/problem-departments";
        }, 1000);
      } catch (error) {
        if (error.response && error.response.data.errors) {
          this.errors = error.response.data.errors;
        } else {
          this.$bvToast.toast("An error occurred. Please try again.", {
            title: "Error",
            variant: "danger",
            solid: true
          });
        }
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>
